import Vue from 'vue';
import VueRouter from 'vue-router';
import SitePage from '@/views/SitePage.vue';
import { metaByKey } from '@/documents/sitePages.js';

Vue.use(VueRouter);

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};

const pageRoute = (path, name, pageKey) => ({
  path,
  name,
  meta: metaByKey[pageKey],
  component: SitePage,
  props: { pageKey }
});

export const constRoutesPc = [
  pageRoute('/', 'pt-home', 'home'),
  pageRoute('/download/', 'pt-download', 'download'),
  pageRoute('/como-atualizar-gb-whatsapp/', 'pt-update', 'update'),
  pageRoute('/como-instalar-gb-whatsapp/', 'pt-install', 'install'),
  pageRoute('/gb-whatsapp-nao-funciona/', 'pt-not-working', 'notWorking'),
  pageRoute('/gb-whatsapp-foi-bloqueado/', 'pt-banned', 'banned'),
  pageRoute('/gb-whatsapp-e-seguro/', 'pt-safe', 'safe'),
  pageRoute('/gb-whatsapp-vs-whatsapp/', 'pt-compare', 'compare'),
  pageRoute('/privacy-policy/', 'pt-privacy', 'privacy'),
  pageRoute('/about-us/', 'pt-about', 'about'),
  pageRoute('/disclaimer/', 'pt-disclaimer', 'disclaimer'),
  { path: '/download', redirect: '/download/' },
  { path: '/como-atualizar-gb-whatsapp', redirect: '/como-atualizar-gb-whatsapp/' },
  { path: '/como-instalar-gb-whatsapp', redirect: '/como-instalar-gb-whatsapp/' },
  { path: '/gb-whatsapp-nao-funciona', redirect: '/gb-whatsapp-nao-funciona/' },
  { path: '/gb-whatsapp-foi-bloqueado', redirect: '/gb-whatsapp-foi-bloqueado/' },
  { path: '/gb-whatsapp-e-seguro', redirect: '/gb-whatsapp-e-seguro/' },
  { path: '/gb-whatsapp-vs-whatsapp', redirect: '/gb-whatsapp-vs-whatsapp/' },
  { path: '/privacy-policy', redirect: '/privacy-policy/' },
  { path: '/about-us', redirect: '/about-us/' },
  { path: '/disclaimer', redirect: '/disclaimer/' }
];

const trailingSlashPaths = new Set(
  constRoutesPc
    .map((route) => route.path)
    .filter((path) => path !== '/' && path.endsWith('/'))
    .map((path) => path.slice(0, -1))
);

export default function createRouter() {
  const router = new VueRouter({
    mode: 'history',
    routes: constRoutesPc,
    scrollBehavior(to, from, savedPosition) {
      if (savedPosition) {
        return savedPosition;
      }
      return { x: 0, y: 0 };
    }
  });

  router.beforeEach((to, from, next) => {
    if (trailingSlashPaths.has(to.path)) {
      next({
        path: `${to.path}/`,
        query: to.query,
        hash: to.hash,
        replace: true
      });
      return;
    }

    next();
  });

  return router;
}
